import { InputSwitch } from "primereact/inputswitch";
import { Controller, useFormContext } from "react-hook-form";

interface IFeatureFlagItem {
  name: string;
  label: string;
  description?: string;
}

const communicationFlags: IFeatureFlagItem[] = [
  {
    name: "features.outreachEnabled",
    label: "Outreach",
    description: "Enable patient outreach (SMS and email reminders)",
  },
];

export function Communications() {
  const { control } = useFormContext<any>();

  return (
    <div className="flex flex-column gap-4 border-bottom-1 border-gray-200 pb-4">
      <span className="font-medium text-sm mb-2 text-gray-600">
        COMMUNICATIONS
      </span>
      {communicationFlags.map((flag) => (
        <div key={flag.name} className="flex gap-3">
          <Controller
            name={flag.name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <InputSwitch
                inputId={flag.name}
                checked={value || false}
                onChange={(e) => onChange(e.value)}
              />
            )}
          />
          <div className="flex flex-column">
            <span className="font-medium text-sm mb-1">{flag.label}</span>
            {flag.description && (
              <span className="text-sm text-gray-500">{flag.description}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
